<template>
  <v-dialog v-model="value" max-width="40%" scrollable persistent>
		<v-card :loading="loading">
			<v-card-title class="title primary--text mb-2 secondary" v-translate>Substances (g)</v-card-title>
			<v-card-text v-if="!loading">
				<v-form ref="substancesForm">
					<v-row no-gutters class="mt-3">
						<v-col v-for="ing in product.product.ingredients" cols="12" :key="ing.id">
							<v-row no-gutters align="center" class="py-3">
								<v-text-field
									v-model="ing.quantity"
									:label="ing.name"
									class="px-2"
									outlined
									type="number"
									hide-details
									:disabled="!ing.selected"
                  :rules="substanceQuantityRules"
								/>
								<v-btn
									class="mx-2"
									dark
									small
									icon
									:color="ing.selected ? 'green' : 'red'"
									@click="ing.selected = !ing.selected"
								>
									<v-icon v-if="ing.selected">mdi-check-circle</v-icon>
									<v-icon v-else>mdi-close-circle</v-icon>
								</v-btn>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-btn
								class="mx-2"
								dark
								x-small
								fab
								color="primary"
								@click="showSearchSubstances = !showSearchSubstances"
							>
								<v-icon>mdi-plus</v-icon>
							</v-btn>
						</v-col>
						<v-col v-if="showSearchSubstances" cols="12" class="mt-2">
							<SearchSubstances @add-product="addSubstance" type="formula"/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn color="primary darken-1" text @click="product.product.selected = false; $emit('input', false)">
					<translate>Cancel</translate>
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" text @click="$emit('save')" :disabled="disabledSaveSubstances" :loading="saving">
					<translate>Save</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import SearchSubstances from '@/components/products/SearchSubstances.vue';

export default {
  name: "OpenFormulaSubstances",
  props: ["value", "product", "loading", "saving"],
  components: {
    SearchSubstances
  },
  data: () => ({
		showSearchSubstances: false
  }),
  computed: {
    disabledSaveSubstances() {
			return this.product.product.ingredients.filter(i => i.selected).length == 0;
		},
    substanceQuantityRules() {
			return [v => !!v || this.$gettext("Required")];
		}
  },
  methods: {
    addSubstance(substance) {
			console.log(substance);
			let newSubstance = {
				id: substance.product.id,
				name: substance.product.name,
				unit: substance.unit,
				quantity: substance.quantity,
				selected: true
			};
			this.product.product.ingredients.push(newSubstance);
      this.showSearchSubstances = false;
		}
  }
}
</script>